import Initial from '../../../components/Initial'
import Panel, { PanelBody } from '../../../components/Panel'
import useInitial from '../useInitial'
import FilterAgents from './FilterAgents'
import Table from './Table'

export default function Agents() {
    const state = useInitial()

    return (
        <Initial pageState={state}>
            <Panel>
                <PanelBody>
                    <FilterAgents />
                    <Table />
                </PanelBody>
            </Panel>
        </Initial>
    )
}
